import { Fragment, type FC } from 'react'
import Image from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'

type DataResponse = {
  title: string
  description: string
  recommendation?: string
} | null

export type DialogPredikatKinerjaTahunanUnavailableProps = {
  isOpen?: boolean
  onClose?: () => void
  data: DataResponse
}

const DialogPredikatKinerjaTahunanUnavailable: FC<
  DialogPredikatKinerjaTahunanUnavailableProps
> = ({ isOpen, onClose, data }) => {
  return (
    <>
      <Dialog
        data-module="pengelolaan-kinerja"
        isOpen={isOpen}
        onClose={onClose}
        size="sm"
        type="modal"
        autoFocus={false}
        closeOnOverlayClick={false}
      >
        <DialogOverlay />
        <DialogContent className="!rounded-lg">
          <div className="p-6 space-y-2">
            <Image
              alt=""
              src="/illustrations/img-empty-document-2.png"
              width={84}
              height={84}
            />
            <Text variant="display-sm">{data.title}</Text>

            <Text variant="body-lg" color="subdued">
              {data.description}
            </Text>

            {data?.recommendation && (
              <div className="bg-surface-warning-subdued rounded-lg p-4 flex gap-2.5 !my-8">
                <Icon color="warning" className="bg-icon-waring">
                  info
                </Icon>
                <Text variant="body" color="default">
                  {data?.recommendation}
                </Text>
              </div>
            )}

            <div className="flex gap-5 !mt-4">
              <Button size="lg" data-testid="btn-confirm" onClick={onClose}>
                Saya mengerti
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default DialogPredikatKinerjaTahunanUnavailable
